//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../Display/Display.UVTransformationData.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnchorType",1,0],[0,"Bump",1,0],[0,"DecalName",1,0],[1,"FaceOrBody",0,"SelectNXObjectList",0],[0,"FilterDecalImages",1,0],[0,"FitPreview",1,0],[1,"Height",0,"Expression",0],[0,"ImageName",1,0],[0,"LockAspectRatio",1,0],[0,"MaximumPixelSize",1,0],[0,"Origin",1,"Point",0],[0,"PixelColorTolerance",1,0],[0,"ProjectionType",1,0],[0,"ReflectivityType",1,0],[1,"RotationAngle",0,"Expression",0],[0,"ScalingMethodType",1,0],[0,"Strength",1,0],[0,"TransparencyType",1,0],[1,"UVTransformationData",0,"Display.UVTransformationData",0],[1,"Width",0,"Expression",0]],[[["origin","csys"],"GetManipulatorData",{},0,0],[["origin","csys"],"SetManipulatorData",{},2,0],[[],"ResetImageSize",{},0,0],[[],"GetTransparencyPixelColor",{R_:{transparencyColor:''}},0,0],[["transparencyColor"],"SetTransparencyPixelColor",{},1,0],[[],"UpdateDecalStickerOnImageDimensionChange",{},0,0]],[]];
SPLM.Display.DecalStickerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.DecalStickerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.DecalStickerBuilder.Color = class{
    constructor(color1,color2,color3){
        this.color1=color1;this.color2=color2;this.color3=color3;}
    get Color1(){return this.color1}
    set Color1(val){this.color1 = val}
    get Color2(){return this.color2}
    set Color2(val){this.color2 = val}
    get Color3(){return this.color3}
    set Color3(val){this.color3 = val}
};

SPLM.Display.DecalStickerBuilder.PixelSizes = Object.freeze({
    "TrueSize" : "TrueSize", "OneTwentyEight" : "OneTwentyEight", "TwoFiftySix" : "TwoFiftySix", "FiveTwleve" : "FiveTwleve", "OneZeroTwoFour" : "OneZeroTwoFour", "TwoZeroFourEight" : "TwoZeroFourEight", "FourZeroNineSix" : "FourZeroNineSix"});

SPLM.Display.DecalStickerBuilder.ProjectionTypes = Object.freeze({
    "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "Uv" : "Uv"});

SPLM.Display.DecalStickerBuilder.AnchorTypes = Object.freeze({
    "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight"});

SPLM.Display.DecalStickerBuilder.ScalingMethodTypes = Object.freeze({
    "UserDefined" : "UserDefined", "ImageSize" : "ImageSize"});

SPLM.Display.DecalStickerBuilder.TransparencyTypes = Object.freeze({
    "None" : "None", "FromImage" : "FromImage", "PixelColor" : "PixelColor"});

SPLM.Display.DecalStickerBuilder.ReflectivityTypes = Object.freeze({
    "FromVisualMaterial" : "FromVisualMaterial", "Matte" : "Matte", "Plastic" : "Plastic", "Mirror" : "Mirror", "Metal" : "Metal", "Glass" : "Glass"});

export default SPLM;